import { ExpandableTable } from "../../../../components/UniversalTable";
import { documentWithoutDatesTableColumns } from "../../../../helpers";
import { BenefitsStatementItem } from "../../../../types/verified/benefits-statement";
import { VerifyMethodType } from "shared/types";
import { ExpandedTableRow } from "./ExpandedTableRow";

export const BenefitsStatementTable = ({
  incomeItems
}: {
  incomeItems: BenefitsStatementItem[];
}) => {
  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300"
      renderExpanded={({ benefitsItem }) => (
        <ExpandedTableRow benefitsItem={benefitsItem} />
      )}
      rows={incomeItems.map((item) => {
        return {
          benefitsItem: item,
          verifyType: VerifyMethodType.BenefitsStatement,
          asset: item.income_source_data?.asset,
          total_gross_pay_amount:
            (item.data?.gross_monthly_income.cents ?? 0) / 100,
          total_net_pay_amount:
            (item.data?.net_monthly_income.cents ?? 0) / 100,
          raw_data: item.income_source_data?.raw_data
        };
      })}
      columns={documentWithoutDatesTableColumns}
    />
  );
};
